console.log("slick-carousel-related.js");
import $ from 'jquery';

class carouselSliderRelated {
  constructor() {
    this.products = $(".related.products .products");
    this.initCarousel();
  }

  initCarousel() {
    this.products.slick({
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      //centerMode: false,
      centerPadding: '2em',
      fade: false, 
      mobileFirst: true,
      arrows: false,
      swipeToSlide: true,
      responsive: [{
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          infinite: true
        }   
      },{
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          infinite: true
        }      
      },{
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        }   
      },{   
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
        }   
      }]
    });  
  }
}

export default carouselSliderRelated;